export enum PageEnum {
  homePage = 'home_page',
  marketing = 'marketing',
}
